import axios from 'axios'
import api from '../api'

export const state = {
  haynes_status: null,
  haynes_message: '',
  repair_times: []
}

export const mutations = {
  SET_HAYNES_STATUS (state, { status, message, repair_times }) {
    state.haynes_status = status
    state.haynes_message = message || ''
    state.repair_times = Array.isArray(repair_times) ? repair_times : []
  },
  RESET_HAYNES_STATUS (state) {
    state.haynes_status = null
    state.haynes_message = ''
    state.repair_times = []
  }
}

export const actions = {
  async get_haynes_status ({ commit }, { vin, cod_motor }) {
    try {
      const { data } = await axios.get(api.haynes, {
        params: { vin, cod_motor },
        // 404 is a legitimate response (status: 'not_found'), not an error.
        validateStatus: s => s < 500
      })
      commit('SET_HAYNES_STATUS', data)
      return data
    } catch (e) {
      // 5xx / network error — surface as terminal 'error' status so the
      // poller stops immediately instead of hammering the server.
      const error_payload = { status: 'error', message: '', repair_times: [] }
      commit('SET_HAYNES_STATUS', error_payload)
      return error_payload
    }
  }
}
